export const messages = ($http: HttpApi) => ({
  list: (params: HttpParams['params'] = {}) => $http.$get('/ai/chat/messages', { params }),
  create: (data: HttpParams['body'] = {}) => $http.$post('/ai/chat/messages', { body: data }),
  update: (id: string, data: HttpParams['body'] = {}) => $http.$patch(`/ai/chat/messages/${id}`, { body: data }),
});
